import { REOPEN_SUBSCRIPTION } from '@/constants'
import { SubscriptionService } from '@/services'
import { isEqual } from 'lodash'
import deliveryNoteMixin from '@/mixins/deliveryNote'

export default {
  mixins: [deliveryNoteMixin],
  methods: {
    updateSubscription(idSubscription, dataUpdateSubscription, dataSubscriptionPatternInitial) {
      const timeUnavailable =
        dataUpdateSubscription.is_available_delivery_time === false ||
        dataUpdateSubscription.isAvailableTimezone === false
      const body = {
        delivery_id: dataUpdateSubscription.delivery_id,
        time_id: timeUnavailable ? null : dataUpdateSubscription.time_id,
        customer_address_id: dataUpdateSubscription.shipping.id,
        delivery_fee: Number(dataUpdateSubscription.delivery_fee) || 0,
        payment_total: Number(dataUpdateSubscription.payment_total),
        subscription_delivery_pattern: {
          id: dataUpdateSubscription.subscription_pattern.id,
          subscription_division_id: dataUpdateSubscription.subscription_pattern.subscription_division_id,
          param1:
            dataUpdateSubscription.subscription_pattern[
              `param${dataUpdateSubscription.subscription_pattern.subscription_division_id}_1`
            ],
          param2:
            dataUpdateSubscription.subscription_pattern[
              `param${dataUpdateSubscription.subscription_pattern.subscription_division_id}_2`
            ],
          param3:
            dataUpdateSubscription.subscription_pattern[
              `param${dataUpdateSubscription.subscription_pattern.subscription_division_id}_3`
            ],
          next_delivery_date: this.Utils.date.getDateString(
            dataUpdateSubscription.subscription_pattern.next_delivery_date
          ),
          next_next_delivery_date: this.Utils.date.getDateString(
            dataUpdateSubscription.subscription_pattern.next_next_delivery_date
          ),
          next_delivery_auto_calculation: dataUpdateSubscription.subscription_pattern.next_delivery_auto_calculation,
          next_next_delivery_auto_calculation:
            dataUpdateSubscription.subscription_pattern.next_next_delivery_auto_calculation,
        },
        subscription_order_item: dataUpdateSubscription.subscription_order_item.map((item) =>
          Object.assign({
            id: item.id,
            quantity: item.quantity,
            product_sku_id: item.product_sku_id,
          })
        ),
        reopen_flag: dataUpdateSubscription.reopen_flag || undefined,
        is_has_order_ship_arranged: dataUpdateSubscription.is_has_order_ship_arranged || false,
        delivery_note_id: dataUpdateSubscription.delivery_note_id,
        delivery_notes: dataUpdateSubscription.delivery_notes,
        bundled_flag: dataUpdateSubscription.bundled_flag,
      }

      return new Promise((resolve, reject) => {
        if (
          dataSubscriptionPatternInitial &&
          isEqual(dataSubscriptionPatternInitial, body.subscription_delivery_pattern)
        ) {
          resolve(REOPEN_SUBSCRIPTION.NO_UDPATE_BEFORE)
        } else {
          SubscriptionService.updateSubscription(idSubscription, body)
            .then(() => resolve(REOPEN_SUBSCRIPTION.UPDATE_BEFORE))
            .catch((err) => reject(err))
        }
      })
    },
  },
}
